"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _Tab = _interopRequireDefault(require("../common/Tab/Tab"));
var _OpenOrders = _interopRequireDefault(require("./OpenOrders"));
var _FilledOrders = _interopRequireDefault(require("./FilledOrders"));
var _InactiveOrders = _interopRequireDefault(require("./InactiveOrders"));
var _TradeReports = _interopRequireDefault(require("./TradeReports"));
var _DepositsStatus = _interopRequireDefault(require("./DepositsStatus"));
var _WithdrawStatus = _interopRequireDefault(require("./WithdrawStatus"));
var _HeaderWithFilter = _interopRequireDefault(require("./HeaderWithFilter"));
require("./OrderHistoryComponent.css");
require("./OrderHistoryTables.css");
var _instrumentPositionSelectors = require("../../redux/selectors/instrumentPositionSelectors");
var _reactI18next = require("react-i18next");
var _reactRouterDom = require("react-router-dom/cjs/react-router-dom");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _getPanes = function _getPanes(_ref) {
  var config = _ref.config,
    selectedInstrument = _ref.selectedInstrument,
    t = _ref.t;
  return [{
    menuItem: t(_OpenOrders["default"].title),
    render: function render() {
      return /*#__PURE__*/_react["default"].createElement(_OpenOrders["default"], {
        config: config,
        selectedInstrument: selectedInstrument
      });
    }
  }, {
    menuItem: t(_FilledOrders["default"].title),
    render: function render() {
      return /*#__PURE__*/_react["default"].createElement(_FilledOrders["default"], {
        config: config,
        selectedInstrument: selectedInstrument
      });
    }
  }, {
    menuItem: t(_InactiveOrders["default"].title),
    render: function render() {
      return /*#__PURE__*/_react["default"].createElement(_InactiveOrders["default"], {
        config: config,
        selectedInstrument: selectedInstrument
      });
    }
  }, {
    menuItem: t(_TradeReports["default"].title),
    render: function render() {
      return /*#__PURE__*/_react["default"].createElement(_TradeReports["default"], {
        config: config,
        selectedInstrument: selectedInstrument
      });
    }
  }, {
    menuItem: t(_DepositsStatus["default"].title),
    render: function render() {
      return /*#__PURE__*/_react["default"].createElement(_DepositsStatus["default"], {
        config: config,
        selectedInstrument: selectedInstrument
      });
    }
  }, {
    menuItem: t(_WithdrawStatus["default"].title),
    render: function render() {
      return /*#__PURE__*/_react["default"].createElement(_WithdrawStatus["default"], {
        config: config,
        selectedInstrument: selectedInstrument
      });
    }
  }];
};
var OrderHistoryComponent = function OrderHistoryComponent(props) {
  var _location$state;
  var config = props.config,
    useHeaderWithFilter = props.useHeaderWithFilter,
    classModifiers = props.classModifiers;
  var _useTranslation = (0, _reactI18next.useTranslation)('order'),
    t = _useTranslation.t;
  var selectedInstrument = (0, _reactRedux.useSelector)(function (state) {
    return config.filterMode === 'selectedInstrument' ? (0, _instrumentPositionSelectors.selectedInstrumentSelector)(state) : undefined;
  });
  var location = (0, _reactRouterDom.useLocation)();
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, useHeaderWithFilter && /*#__PURE__*/_react["default"].createElement(_HeaderWithFilter["default"], null), /*#__PURE__*/_react["default"].createElement(_Tab["default"], {
    defaultActiveIndex: ((_location$state = location.state) === null || _location$state === void 0 ? void 0 : _location$state.historyTableIndex) || 0,
    panes: _getPanes({
      config: config,
      selectedInstrument: selectedInstrument,
      t: t
    }),
    classModifiers: classModifiers,
    customClass: "order-history"
  }));
};
var mapStateToProps = function mapStateToProps(state, _ref2) {
  var config = _ref2.config;
  return {
    selectedInstrument: config.filterMode === 'selectedInstrument' ? (0, _instrumentPositionSelectors.selectedInstrumentSelector)(state) : undefined
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps)(OrderHistoryComponent);